import timeutils from 'utils/wt-time-utils'
// 通用表单数据显示(第一个参数为获取的表单数据，第二个微表单的类型信息)
export function itemFiledsData (data, val) {
  let result = null
  switch (val.fieldType) {
    case 'SELECT':
      if (val.optionsEnum === 'hospital' || val.optionsEnum === 'lifeExperienceHall' || val.optionsEnum === 'lifeExperienceHallVisit') {
        result = (data[val.key] && data[val.key].name) || data[val.key]
      }
      if (val.optionsEnum === 'lifeExperienceHallVisitTime') {
        result = data[val.key] && timeutils.format(data[val.key], 'date')
      }
      if (val.options && val.options.length) {
        if (val.multiple) {
          val.options.forEach(item => {
            if (data[val.key] && data[val.key].length) {
              data[val.key].forEach(etem => {
                if (etem === item.value) {
                  result = result ? (result + '/' + item.label) : item.label
                }
              })
            }
          })
        } else {
          val.options.forEach(item => {
            if (data[val.key] === item.value) {
              result = item.label
            }
          })
        }
      }
      break
    case 'RADIO':
      if (val.options && val.options.length) {
        val.options.forEach(item => {
          if (item.isAdditionalType) {
            if ((data[val.key] && data[val.key].value) === item.value) {
              result = item.label + '  ' + data[val.key].additionalInfo
            }
          } else {
            if (data[val.key] === item.value) {
              result = item.label || item.value
            }
            if (data[val.key] && !result) {
              result = data[val.key]
            }
          }
        })
      }
      break
    case 'CHECKBOX':
      if (val.options && val.options.length) {
        val.options.forEach(item => {
          if (data[val.key] && data[val.key].length) {
            data[val.key].forEach(etem => {
              if (etem === item.value) {
                result = result ? (result + '/' + item.label) : item.label
              }
            })
          }
        })
      }

      break
    case 'ADDRESS_SELECT':
      if (data[val.key] && data[val.key].length) {
        data[val.key].forEach(item => {
          result = result ? result + item.text : item.text
        })
      }
      break
    case 'DATE':
      result = data[val.key] && timeutils.format(data[val.key], 'date')
      break
    default:
      result = data[val.key]
                // case 'ADDRESS_SELECT':
  }
  if (val.key === 'identityCardType') {
    let idCaredType = val.options.find(item => item.value === 'CHINESE_IDENTITY_CARD') || {}
    let idCaredName = idCaredType.label
    result = result || idCaredName || '身份证'
  }
  return result
  // return data[val.key]
}

// 报名记录的筛选条件
export function filterLabels (data, hospitalList, provinceList) {
  //   console.log('data', data)
  let result = []
  data.forEach(item => {
    let filterObj = {}
    if (item.needFilter) {
      filterObj.label = item.label
      filterObj.clearable = true
      filterObj.value = item.key
      filterObj.needFilter = item.needFilter
      switch (item.fieldType) {
        case 'DATE':
          filterObj.type = 'time-slot'
          filterObj.startName = 'start'
          filterObj.endName = 'end'

          break
        case 'RADIO':
          filterObj.type = 'select'
          filterObj.options = item.options
          break
        case 'SELECT':
          filterObj.type = 'select'
          if (item.optionsEnum && item.optionsEnum === 'hospital') {
            filterObj.options = hospitalList || []
            filterObj.props = {
              label: 'name',
              value: 'id'
            }
          } else {
            filterObj.options = item.options
          }
          break
        case 'ADDRESS_SELECT':
          filterObj.type = 'select'
          filterObj.options = provinceList || []
          filterObj.props = {
            label: 'province',
            value: 'gbCode'
          }
          break
        case 'CHECKBOX':
          filterObj.type = 'select'
          filterObj.options = item.options
          break
        default:
          filterObj.type = 'input'
      }
      result.push(filterObj)
    }
  })
  return result
}
